import { API } from "api/axios.config";
import { createApplicationService } from "./base/applicationServiceBase";

const APPLICATION_SETTINGS_BASE = "/settings/application";

const getApplicationSettingsAPI = () => API.get(APPLICATION_SETTINGS_BASE);

const updateApplicationSettingsAPI = (data) =>
  API.put(APPLICATION_SETTINGS_BASE, data, {
    headers: { "Content-Type": "application/json" },
  });

const baseService = createApplicationService({
  name: "applicationSettings",
  apiFetchFn: getApplicationSettingsAPI,
  apiUpdateFn: updateApplicationSettingsAPI,
});

const applicationSettingsReducer = baseService.reducer;
const getApplicationSettings = baseService.getData;
const updateApplicationSettings = baseService.updateData;
const useApplicationSettings = baseService.useData;

export {
  applicationSettingsReducer,
  getApplicationSettings,
  updateApplicationSettings,
  useApplicationSettings,
};
